import React from 'react';

// Full-screen bootstrap indicator. Shown while we verify the stored token,
// resolve cinfo/apir, and fetch uinfo — typically <1 second after auth.
// Uses design tokens so the first paint already looks like the real app.

const Loading = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--paper)',
      color: 'var(--ink-3)',
      gap: 14,
    }}
  >
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
      <circle cx="22" cy="22" r="18" stroke="var(--rule)" strokeWidth="2"/>
      <path
        d="M22 4 A 18 18 0 0 1 40 22"
        stroke="var(--orange)"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 22 22"
          to="360 22 22"
          dur="0.9s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
    <div className="label" style={{ letterSpacing: '0.14em' }}>
      LOADING SALES ASSIST
    </div>
  </div>
);

export default Loading;
